// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-listings[data-v-7ddbd458]{min-height:450px}.fade-enter-active[data-v-7ddbd458],.fade-leave-active[data-v-7ddbd458]{transition:.5s}.fade-enter[data-v-7ddbd458],.fade-leave-to[data-v-7ddbd458]{opacity:0}.item[data-v-7ddbd458]{margin-bottom:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
